export interface CustomMediaOptions {
  min?: string
  max?: string
}

export const theme = {
  colors: {
    primary: "#5B4EB9",
    primary10: "#160067",
    primary20: "#2C1789",
    primary30: "#4334A0",
    primary40: "#5B4EB9",
    primary50: "#7568D5",
    primary60: "#8F82F1",
    primary70: "#AB9FFF",
    primary80: "#D2BCFF",
    primary90: "#C8BFFF",
    primary95: "#F4EEFF",
    primary99: "#FAF8FF",

    secondary: "#FF43A3",
    secondary10: "#3E0020",
    secondary20: "#640037",
    secondary30: "#8D0050",
    secondary40: "#B8006B",
    secondary50: "#E01B87",
    secondary60: "#FF43A3",
    secondary70: "#FF82B8",
    secondary80: "#FFAFCE",
    secondary90: "#FFD9E6",
    secondary95: "#FFECF1",
    secondary99: "#FFECF1",

    success: "#00A56C",
    success10: "#002112",
    success20: "#003822",
    success30: "#005233",
    success40: "#006C45",
    success50: "#008858",
    success60: "#00A56C",
    success70: "#2DC286",
    success80: "#53DEA0",
    success90: "#72FBBA",
    success95: "#BCFFDA",
    success99: "#F3FFF6",

    error: "#FF5449",
    error10: "#410001",
    error20: "#680003",
    error30: "#930006",
    error40: "#BA1B1B",
    error50: "#DD3730",
    error60: "#FF5449",
    error70: "#FF897A",
    error80: "#FFB4A9",
    error90: "#FFDAD4",
    error95: "#FFEDE9",
    error99: "#FFF9F9",

    warning: "#FFB349",
    warning10: "#412600",
    warning20: "#683D00",
    warning30: "#935600",
    warning40: "#BA781B",
    warning50: "#DD9530",
    warning60: "#FFB349",
    warning70: "#FFC87A",
    warning80: "#FFDBA9",
    warning90: "#FFEDD4",
    warning95: "#FFF6E9",
    warning99: "#FFFCF9",

    // Greys
    black: "#000000",
    white: "#FFFFFF",

    gray0: "#000000",
    gray10: "#1D1B1F",
    gray20: "#323033",
    gray30: "#484649",
    gray40: "#605D61",
    gray50: "#79767A",
    gray60: "#938F94",
    gray70: "#AEAAAE",
    gray80: "#C7C5CA",
    gray90: "#E3E1E6",
    gray95: "#F3EFF5",
    gray99: "#FDFBFF",

    defaultBackground: "#FDFBFF",
  },
  shadow: {
    default: "0 1px 5px 0 rgba(0,0,0,0.1);",
    button: "0 2px 4px 0 rgba(0,0,0,0.25);",
    primary: "0px 8px 32px 0px rgba(27, 12, 55, 0.12)",
    elevation1: "0px 0px 5px rgba(36, 15, 75, 0.12)",
    elevation2: "-2px 2px 12px rgba(36, 15, 75, 0.25)",
    elevation3: "0px 8px 32px rgba(27, 12, 55, 0.12)",
  },
  media: {
    mobile: "@media screen and (max-width: 480px)",
    pad: "@media screen and (max-width: 950px)",
    desktop: "@media screen and (min-width: 951px)",
  },
  button: {
    reset: `
      background: none;
      border: none;
      padding: 0;
      font: inherit;
      cursor: pointer;
      outline: inherit;
    `,
  },
  mediaCustom: ({ min, max }: CustomMediaOptions) =>
    `@media screen ${min ? `and (min-width: ${min})` : ""} ${
      max ? `and (max-width: ${max})` : ""
    }`,

  layout: {},

  sizes: {
    headerHeight: "56px",
    headerHeightMobile: "56px",
    sidebarWidth: "256px",
    defaultBorderRadius: "8px",
    defaultInputHeight: "48px",
  },
}

export default theme
